import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { white, black200, black700, cinnabar300, blue300 } from '../../../theme/colors';
import themeSizes from '../../../theme/themeSizes';
import { baseCaption } from '../../../theme/typography';
import { useRef } from 'react';
import { uploadOutletImages } from '../../../actions/outlet/uploadOutletImages';
import { useState } from 'react';
import { useEffect } from 'react';

const textboxStyle = `
    min-height:42px;
    border-radius: 2px;
    box-sizing: border-box;
    color: ${black700}; 
    display:flex;   
    flex-wrap: wrap;
    position: relative;
`;

const ImageRow = styled.div`
    display: flex;
    gap: 8px;
    overflow-x: auto;
`;

const ImageWrapper = styled.div`
    width: 120px;
    height: 120px;
    position: relative;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

const ViewAllOverlay = styled.div`
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    color: ${white};
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
`;


const TextBoxStyle = styled.div`
    ${baseCaption};
    width: ${({ boxWidth }) => boxWidth || 'auto'};
    >div{
        ${textboxStyle};
        padding: ${({ boxPadding }) => boxPadding || '12px 16px'}; 
        margin: ${({ boxMargin }) => boxMargin}; 
        width: ${({ boxWidth }) => boxWidth || `540px`};
        max-width: ${({ isSearchBox }) => isSearchBox && `240px`};
        ${props => props.noBorder && css`
            border: none
        `}
        ${props => props.errorLine && css`
            border: 1px solid ${cinnabar300};
        `};
        align-items: center;
        min-height: ${({ boxHeight }) => boxHeight || `42px`};
        input{
            border:none;
            outline:none;

            flex:1;
            min-width: 1px; 
            width:0;
            background: ${({ isSearchBox, background }) => isSearchBox ? `transparent` : background || `${white}`};
            ${baseCaption}
            ::placeholder {
                color: #909191;
            }
        }
        span {
            svg{
                width:18px;
                height:18px;
                vertical-align: -6px;
            };
        } 
        :after{
            ${props => props.disabled && css`
                cursor: not-allowed;
                content:' ';
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;
            `};
        };
        @media ${themeSizes.tablet} {
            width:100% !important;
          }
    } 
    /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        }

        /* Firefox */
        input[type=number] {
        -moz-appearance: textfield;
        };
        
`;

const OutSideIcon = styled.span`
        position: absolute;
        right: -36px;
        top: 10px;
`;

const MessageBelowBoxStyle = styled.p`
    ${baseCaption}
    margin:5px 0 0;
    display:flex;
    justify-content:space-between;
    width: ${({ boxWidth }) => boxWidth || `540px`};
    &>span:first-child{
        color: ${cinnabar300};
        order: ${props => props.errorTextAlign === 'right' || props.subTextAlign === 'left' ? 2 : 1};
        ${props => props.cursorPointer && css`
            cursor:pointer;
        `}
        ${props => props.subTextDisabled && css`
            cursor:not-allowed;
        `}
    }
    &>span:last-child{
        color: ${blue300};
        order: ${props => props.errorTextAlign === 'right' || props.subTextAlign === 'left' ? 1 : 2};
        ${props => props.cursorPointer && css`
            cursor:pointer;
        `}
        ${props => props.subTextDisabled && css`
            cursor:not-allowed;
        `}
    };
    
`;

export const ImageListView = ({
    rightIcon = '',
    outsideIcon,
    warnMessage = {
        align: 'right',
        errorLine: true
    },
    subText = {},
    onChange = () => { },
    onClick = () => { },
    onEnter = () => { },
    handleOutsideIconClick,
    isSearchBox = false,
    boxWidth,
    disabled,
    background,
    boxHeight,
    boxPadding,
    boxMargin,
    isQCEditable = false,
    noBorder = false,
    imageUrls = [],
    onViewAll = () => { },
    imageUploadCallback = () => { },
    uploadedImageRemoveCallback = () => { },
    onImageClick = () => { },

}) => {
    const fileInputRef = useRef(null);
    const [answerImageUrl, setAnswerImageUrl] = useState([]);

    const errorMessage = warnMessage.text;
    const showMessage = errorMessage || Object.keys(subText).length;

    useEffect(() => {
        setAnswerImageUrl(imageUrls || [])
    }, [imageUrls])

    const handleUploadClick = () => {

        // if (imageUploadQuestion != null) {
        //     let alreadyUploadedImageIds = imageUploadQuestion.related_answers?.[0]?.multiple_images_input?.length || 0;
        //     let totalUploadedImages = uploadedImageList.length - 1 + alreadyUploadedImageIds;


        //     if (totalUploadedImages >= parseInt(imageUploadQuestion.validations.max_images_count)) {
        //         triggerNotification({
        //             messageText: "Maximum image limit exceeded. You can only upload maximum of " + imageUploadQuestion.validations.max_images_count + " images for this question.",
        //             status: "FAILED",
        //         });
        //     } else {
        //         fileInputRef.current.click();
        //     }
        // } else {
        fileInputRef.current.click();
        // }
    };

    const handleFileSelect = (event) => {
        const input = event.target;

        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        // setIsUploading(true);

        // uploadOutletImages(files)
        //     .then(response => {
        //         const newData = response.map(item => ({
        //             id: item.id,
        //             image_url: item.image
        //         }));

        //         // const newDataId = response.map(item => item.id);

        //         // setAnswerImageUrl(prev => [...newData, ...prev])
        //         imageUploadCallback(newData)
        //         // setIsUploading(false);
        //         input.value = null;
        //     })
        //     .catch(() => {
        //         alert('Some images failed to upload');
        //         // setIsUploading(false);
        //         input.value = null;
        //     });
    };

    const handleRemoveCurrentSurveyImage = (imageId) => {
        uploadedImageRemoveCallback(imageId)
        // setAnswerImageUrl(answerImageUrl.filter(item => item.id !== imageId));
    };

    return (
        <TextBoxStyle
            isOutSide={outsideIcon}
            isSearchBox={isSearchBox}
            errorLine={warnMessage.onlyTextError ? false : warnMessage.text}
            onChange={onChange}
            boxWidth={boxWidth}
            disabled={false}
            background={background}
            boxHeight={boxHeight}
            boxPadding={boxPadding}
            boxMargin={boxMargin}
            noBorder={noBorder}

        >
            <div>

                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: 'none' }}
                    onChange={handleFileSelect}
                />

                <ImageRow>

                    {isQCEditable == true && (
                        <div>
                            <div
                                onClick={handleUploadClick}
                                style={{
                                    width: 96,
                                    height: 96,
                                    backgroundColor: "#ffffff",
                                    border: "2px dashed #cfcfcf",
                                    borderRadius: 6,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <div
                                    style={{
                                        width: 44,
                                        height: 44,
                                        borderRadius: "50%",
                                        backgroundColor: "#d9d9d9",
                                        color: "#ffffff",
                                        fontSize: 28,
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    +
                                </div>
                            </div>
                        </div>

                    )}
                    {answerImageUrl.slice(0, 5).map((url, index) => {
                        const isLastImage = index === 2 && answerImageUrl.length > 3;

                        return (
                            <ImageWrapper
                                key={index}
                            // onClick={() => onViewAll(answerImageUrl.map(item => item.image_url), index)
                            // }
                            >
                                <img
                                    onClick={() => onViewAll(answerImageUrl.map(item => item.image_url), index)}
                                    src={url.image_url} alt={`img-${index}`} />
                                {/* {url.id > 0 && (
                                    <div
                                        onClick={() => handleRemoveCurrentSurveyImage(url.id)}
                                        style={{
                                            position: "absolute",
                                            top: 4,
                                            right: 8,
                                            color: "red",
                                            borderRadius: "50%",

                                        }}
                                    >
                                        <img src={require("./image_close.png")}
                                            style={{
                                                width: 24,
                                                height: 24,

                                            }} />
                                    </div>
                                )} */}

                               
                            </ImageWrapper>
                        );
                    })}
                </ImageRow>
                <span onClick={onClick}>{rightIcon}</span>
                {outsideIcon && <OutSideIcon onClick={handleOutsideIconClick}>{outsideIcon}</OutSideIcon>}
            </div>
            {showMessage ?
                <MessageBelowBoxStyle
                    errorTextAlign={errorMessage && warnMessage.align}
                    subTextAlign={subText.align}
                    boxWidth={boxWidth}
                    cursorPointer={Boolean(subText.onClick)}
                    subTextDisabled={subText.disabled}
                >
                    <span style={warnMessage.position ? { position: warnMessage.position } : {}}>{warnMessage.text}</span>
                    <span onClick={() => !subText.disabled ? subText.onClick() : () => { }}>{subText.text}</span>
                </MessageBelowBoxStyle>
                : null}
        </TextBoxStyle>
    )
}
